"use client";

import dynamic from "next/dynamic";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import Card from "./Card";
import DynamicLoader from "@/components/CustomUI/modules/Loaders/DynamicLoader";

const NoProducts = dynamic(() => import("../NoProducts"), { suspense: true, loading: () => <DynamicLoader /> });

const List = ({ initialData }) => {
  const data = useSelector((state) => state.catalog.data?.products);
  const products = data ?? initialData;
  // FIXME: find a better way to handle a single product css issue
  const renderProducts = useCallback(() => {
    return products.map((product, i) => (
      <Card
        key={(product.pk || product.url_name) + "_" + i}
        product={product}
        currentIndex={i}
        singleProduct={products.length === 1}
      />
    ));
  }, [products]);

  if (!products || products.length === 0) return <NoProducts />;
  return (
    <section
      className="
      grid grid-cols-2 md:grid-cols-3 
      xl:grid-cols-4 gap-2 sm:gap-3 
      md:gap-2 lg:gap-4 pt-3
      "
    >
      {renderProducts()}
    </section>
  );
};

export default List;
